import type { ReactNode } from 'react';

import type { NavItemConfigWithCustomizationOptions } from '../../types';

export function getElemBeforeForItem(item?: NavItemConfigWithCustomizationOptions): ReactNode {
	if (!item || (item.type === 'custom' && item.dragPreviewContent)) {
		// If the custom item has a drag preview content, we should assume it contains the icon already
		return undefined;
	}

	return item.elemBefore;
}

export function getDragPreviewContentForItem(
	item?: NavItemConfigWithCustomizationOptions,
	name?: string,
): ReactNode {
	if (!item) {
		if (name) {
			return name;
		}
		return undefined;
	}
	if (item.type === 'custom' && item.dragPreviewContent) {
		// Custom items may return their drag preview content as a React node
		return item.dragPreviewContent;
	}

	// If not custom or drag preview content not present, use the label
	return item.labelElem ?? item.label;
}
